import lodash from 'lodash';
import React from 'react';
import { DisplayFieldsFragment } from '../../../../../../generated/core-api/graphql-react-query';
import { LatestDetection } from '../../../../../LiveContext/NewSessionContext/Contexts/SessionDetectionContextProvider/useSessionDetectionContext';
import formatDetectionGroup from './utils/formatDetectionGroup';

export default function useDetectionVisibility(detections: (LatestDetection & { cardTitle: string, commandTitle: string })[], tab: { index: number, updatedAt: number }, latestDetection: LatestDetection | null, display?: DisplayFieldsFragment | null) {
  const [complianceOpenedAt, setComplianceOpenedAt] = React.useState<number | null>(null);
  const [cardsVisibility, setCardsVisibility] = React.useState<{ cardId: string, seenAt: number }[]>([]);

  React.useEffect(() => {
    if (tab.index === 1) {
      setComplianceOpenedAt(tab.updatedAt);
    }
  }, [tab]);

  React.useEffect(() => {
    if (display) {
      setCardsVisibility((prev) => {
        const others = prev.filter((item) => item.cardId !== display.cardId);
        return [{ cardId: display.cardId, seenAt: Date.now() }, ...others];
      });
    }
  }, [display, latestDetection]);

  const detectionBadges = React.useMemo(() => {
    const map = new Map<string, number>();
    cardsVisibility.forEach((item) => {
      map.set(item.cardId, item.seenAt);
    });
    return map;
  }, [cardsVisibility]);

  const value = React.useMemo(
    () => {
      const displayDetections = detections.filter((detection) => !!detection.cardId);
      const groupedDetections = Object.values(lodash.groupBy(displayDetections, 'cardId'));
      return groupedDetections
        .map((detectionGroup) => formatDetectionGroup(detectionGroup, detectionBadges, complianceOpenedAt))
        .sort((a, b) => (b.lastOccurrence - a.lastOccurrence));
    },
    [detections, detectionBadges, complianceOpenedAt],
  );

  return value;
}
